module.exports = __webpack_public_path__ + "img/logo-ispace-tech.39d001bd.svg";